import i18next from 'i18next'
import enNs1 from '../../backend/src/locales/en/translation.json'
import frNs1 from '../../backend/src/locales/fr/translation.json'

export const defaultNS = 'frontend'

i18next.init({
    lng: globals.vars.locales,
    debug: false,
    fallbackLng: 'en',
    defaultNS,
    resources: {
        en: {
            frontend: enNs1
        },
        fr: {
            frontend: frNs1
        },
    },
})

export default i18next
